import type { BiggoMigrationStatus, QuizGroupAssociation } from '@/types/quizSet'

export const ALL_BIGGO_MIGRATION_STATUSES = '__all__'

export const BIGGO_MIGRATION_STATUS_OPTIONS: ReadonlyArray<{
  value: BiggoMigrationStatus
  label: string
}> = [
  { value: 'BIGGO', label: 'Biggo' },
  { value: 'DISCARDED', label: '폐기' },
  { value: 'ON_HOLD', label: '보류' },
  { value: 'CONFIRMED', label: '확정' },
  { value: 'UNCONFIRMED', label: '미확인' },
]

const BIGGO_MIGRATION_STATUS_LABELS = new Map(
  BIGGO_MIGRATION_STATUS_OPTIONS.map((option) => [option.value, option.label]),
)

export function getBiggoMigrationStatus(
  association: QuizGroupAssociation,
): BiggoMigrationStatus {
  return association.group.biggoMigrationStatus ?? 'UNCONFIRMED'
}

export function getBiggoMigrationStatusLabel(status: BiggoMigrationStatus): string {
  return BIGGO_MIGRATION_STATUS_LABELS.get(status) ?? status
}

export function filterAssociationsByBiggoMigrationStatus(
  associations: QuizGroupAssociation[],
  status: string,
): QuizGroupAssociation[] {
  if (status === ALL_BIGGO_MIGRATION_STATUSES) return associations
  return associations.filter((association) => getBiggoMigrationStatus(association) === status)
}
